import { useState } from "react";
import { Button, Spinner, Box, Text } from "@chakra-ui/react";
import axios from "axios";
import DisplayImage from "./displayImage";

function UploadImage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);
  const [inputImage, setInputImage] = useState(null);
  const [outputImage, setOutputImage] = useState(null);
  const [isLoading, setIsloading] = useState(false);
  const [score, setScore] = useState(null);

  const fileUploadHandler = () => {
    setIsloading(true);
    const fd = new FormData();
    fd.append("file", selectedFile, selectedFile.name);
    axios
      .post("/api/hypoAI/rest", fd)
      .then((res) => {
        setInputImage(res.data.image);
        setOutputImage(res.data.mask);
        setScore(res.data.score);
        selectedFile(null);
        setError(null);
        setIsloading(false);
      })
      .catch((error) => {
        setSelectedFile(null);
        setError(error.data);
        setIsloading(false);
      });
  };

  const fileData = () => {
    if (selectedFile) {
      if (
        selectedFile.type === "image/jpeg" ||
        selectedFile.type === "image/png"
      ) {
        return (
          <div>
            {error ? (
              <Text fontFamily='Fjord One' color='red' fontSize='18px'>
                {error.data}
              </Text>
            ) : (
              <div>
                <Button
                  colorScheme='teal'
                  size='sm'
                  onClick={() => fileUploadHandler()}
                >
                  Upload!
                </Button>
              </div>
            )}
          </div>
        );
      } else {
        return (
          <Box>
            <Text fontFamily='Fjord One' color='white' fontSize='18px'>
              Please choose an image to upload
            </Text>
          </Box>
        );
      }
    } else {
      return (
        <Box paddingTop='5px'>
          <Text
            fontFamily='Fjord One'
            color='white'
            fontSize='18px'
            textAlign='center'
          >
            Choose Photos
          </Text>
        </Box>
      );
    }
  };

  return (
    <Box
      mt='40px'
      display='flex'
      flexDir='column'
      alignItems='center'
      paddingTop='20px'
    >
      <input
        type='file'
        onChange={(e) => setSelectedFile(e.target.files[0])}
        style={{
          color: "white",
          fontSize: "19px",
        }}
      />
      {fileData()}
      {isLoading ? (
        <Box mt={5} display='flex' flexDir='column' alignItems='center'>
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.500'
            size='xl'
          />
        </Box>
      ) : (
        <Box display='flex' flexDir='column' alignItems='center' width='70%'>
          <DisplayImage
            inputImage={inputImage}
            outputImage={outputImage}
            score={score}
          />
        </Box>
      )}
    </Box>
  );
}
export default UploadImage;
